import { genericPage, getServerSidePropsHelper } from 'components/corporatiu/Page';
import { useRouter } from 'next/router';

const path = ['web', process.env.FOLDER_LAYOUTS_CORPORATIU, 'catradio', 'programacio'];

const Pagina = (props) => {
    const router = useRouter();
    return genericPage(props, router, path);
};

export async function getServerSideProps(context) {
    const { slug } = context.query;
    let idCanal = '';
    switch (slug) {
        case 'catalunya-radio':
            idCanal = 'CATRADIO';
            break;
        case 'catalunya-musica':
            idCanal = 'CATMUSICA';
            break;
        case 'icat':
            idCanal = 'CATCULTURA';
            break;
        case '3catinfo-radio':
            idCanal = 'CATINFORMA';
            break;
        default:
            return {
                notFound: true
            };
    }
    const options = {
        slugs: path,
        id: idCanal
    };
    return getServerSidePropsHelper(context, options);
}

export default Pagina;
